function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_641",
  "data-name": "Group 641",
  transform: "translate(-821 -375)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_25",
  "data-name": "Ellipse 25",
  cx: 21,
  cy: 21,
  r: 21,
  transform: "translate(821 375)",
  fill: "#eeeff3"
}), /*#__PURE__*/React.createElement("g", {
  id: "school_black_24dp_2_",
  "data-name": "school_black_24dp (2)",
  transform: "translate(829 384)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_126",
  "data-name": "Path 126",
  d: "M0,0H24V24H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_127",
  "data-name": "Path 127",
  d: "M5,13.18v2.81a2.011,2.011,0,0,0,1.04,1.76l5,2.73a1.986,1.986,0,0,0,1.92,0l5-2.73A2.011,2.011,0,0,0,19,15.99V13.18l-6.04,3.3a1.986,1.986,0,0,1-1.92,0Zm6.04-9.66L2.61,8.12a1.007,1.007,0,0,0,0,1.76l8.43,4.6a1.986,1.986,0,0,0,1.92,0L21,10.09V16a1,1,0,0,0,2,0V9.59a1.006,1.006,0,0,0-.52-.88L12.96,3.52a2.04,2.04,0,0,0-1.92,0Z",
  fill: "#cc96f1"
})));

var SvgProgramType = function SvgProgramType(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProgramType, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/program-type.be4f4054.svg";
export { ForwardRef as ReactComponent };